<template>
    <Message 
        v-if="statusInfo && statusInfo.requiresAttention" 
        :severity="statusInfo.severity" 
        :closable="dismissible"
        @close="onDismiss"
        class="mb-0"
    >
        <div class="flex items-center gap-2">
            <span>{{ bannerMessage }}</span>
            <RouterLink 
                v-if="isTenantAdmin" 
                :to="{ name: 'settings-billing' }" 
                class="underline font-semibold"
            >
                {{ t('billing.subscription.banner.click_here') }}
            </RouterLink>
        </div>
    </Message>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { RouterLink } from 'vue-router'
import { storeToRefs } from 'pinia'
import Message from 'primevue/message'
import { useTenantsStore } from '@/stores/tenants'
import { useFeaturesStore } from '@/stores/features'
import { TenantSubscriptionStatus } from '@/models/Tenant'

const { t } = useI18n()
const tenantsStore = useTenantsStore()
const featuresStore = useFeaturesStore()
const { subscriptionStatusInfo } = storeToRefs(tenantsStore)

const isTenantAdmin = computed(() => featuresStore.isTenantAdmin)

const statusInfo = computed(() => {
    const info = subscriptionStatusInfo.value
    if (!info || !info.requiresAttention) return null
    return {
        status: info.status as TenantSubscriptionStatus,
        severity: info.severity,
        messageKey: info.messageKey,
        actionRequired: info.actionRequired,
        requiresAttention: info.requiresAttention,
    }
})

const dismissible = computed(() => {
    if (!statusInfo.value) return false
    const status = statusInfo.value.status
    // Only allow dismissing non-critical statuses
    return status === TenantSubscriptionStatus.TRIALING || status === TenantSubscriptionStatus.CANCELED
})

const bannerMessage = computed(() => {
    if (!statusInfo.value) return ''
    if (isTenantAdmin.value) {
        return t('billing.subscription.banner.issue_admin')
    }
    return t('billing.subscription.banner.issue_non_admin')
})

const onDismiss = () => {
    // Could store dismissal in localStorage if needed
    // For now, just hide the banner
}
</script>

